import { Configuration, FrontendApi, ResponseError, type Session } from '@ory/client-fetch';

/**
 * Get the session
 * @returns The session or null if the session is not found
 */
export async function getSession(): Promise<Session | null> {
  try {
    return await new FrontendApi(
      new Configuration({
        basePath: import.meta.env.VITE_KRATOS_URL,
        credentials: 'include',
      })
    ).toSession({});
  } catch (err) {
    if (err instanceof ResponseError) {
      if (err.response.status === 401) {
        return null;
      }
    }

    throw err;
  }
}
